import { FC } from 'react';

import useProgressiveWerklijnen from '@/apps/mwd-v2/hooks/useProgressiveWerklijnen';
import { legendMarginBottomPx } from '@/apps/mwd-v2/utils/timescale';
import { useBamAuth } from '@/auth';

import LegendLeftItem from './LegendLeftItem';

import styles from './LegendLeft.module.css';

const MwdLegendLeftContainer: FC = () => {
  const { werklijnen, mwd } = useProgressiveWerklijnen();
  const { hasPermission } = useBamAuth();
  const isAllowedToMutate = hasPermission('mwd.mutate');
  const isAllowedToInregelingen = hasPermission('mwd.inregelingen');

  return (
    <div
      id='mwdLegendLeftContainer'
      className={styles.legendLeftContainerStyle}
      style={{ height: `${mwd.height + legendMarginBottomPx}px` }}
    >
      <svg width={128} height={mwd.height} viewBox={`0 0 128 ${mwd.height}`}>
        {werklijnen.map((werklijn) => (
          <g key={werklijn.werklijnId} id={`mwdLegendLeft-${werklijn.werklijnId}`}>
            <LegendLeftItem
              legendLeft={werklijn.left}
              height={werklijn.height}
              y={werklijn.y}
              isAllowedToMutate={isAllowedToMutate}
              isAllowedToInregelingen={isAllowedToInregelingen}
            />
          </g>
        ))}
      </svg>
    </div>
  );
};
export default MwdLegendLeftContainer;
